import { User } from './user';

export interface LoginFormValues {
  email: string;
  password: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface MFACredentials {
  code: string;
  token: string;
}

export interface MFAFormValues {
  code: string;
}

export interface AuthResponse {
  user: User;
  token: string;
  mfaRequired?: boolean;
  mfaToken?: string;
}

export enum UserRole {
  ADMIN = 'admin',
  BILLER = 'biller',
  CLINICIAN = 'clinician',
  TECHNICIAN = 'technician',
  CONSULTANT = 'consultant',
  REMOTE_CLINICIAN = 'remote_clinician',
  PATIENT = 'patient',
}

export const UserRoleLabel: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'Admin',
  [UserRole.BILLER]: 'Biller',
  [UserRole.CLINICIAN]: 'Non-Eye Clinician',
  [UserRole.TECHNICIAN]: 'Technician',
  [UserRole.CONSULTANT]: 'Consultant',
  [UserRole.REMOTE_CLINICIAN]: 'Remote Reading Eye Clinician',
  [UserRole.PATIENT]: 'Patient',
};

export const UserRolePluralLabels: Record<UserRole, string> = {
  [UserRole.ADMIN]: 'Admins',
  [UserRole.BILLER]: 'Billers',
  [UserRole.CLINICIAN]: 'Non-Eye Clinicians',
  [UserRole.TECHNICIAN]: 'Technicians',
  [UserRole.CONSULTANT]: 'Consultants',
  [UserRole.REMOTE_CLINICIAN]: 'Remote Reading Eye Clinicians',
  [UserRole.PATIENT]: 'Patients',
};

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => Promise<void>;
  verifyMFA: (credentials: MFACredentials) => Promise<void>;
  resendMFACode: (token: string) => Promise<void>;
  updateUser: (user: Partial<User>) => Promise<void>;
  register: (email: string, password: string) => Promise<void>;
}
